import { render, staticRenderFns } from "./update-edit.vue?vue&type=template&id=19ed4da4&scoped=true"
import script from "./update-edit.vue?vue&type=script&lang=js"
export * from "./update-edit.vue?vue&type=script&lang=js"
import style0 from "./update-edit.vue?vue&type=style&index=0&id=19ed4da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ed4da4",
  null
  
)

export default component.exports